// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3e2Zg","title":"FrontImage_title__3gjPk"};